export default {
  xxsmall: 10,
  xsmall: 15,
  small: 20,
  medium: 40,
  large: 60,
  xlarge: 120,
};
